import React from 'react'
import { Image, ListGroup } from 'react-bootstrap'
import { EMPTY_ARRAY } from '../../constants/globalConstants'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import NoData from '../NoData'
// import deleteImage from '../../assets/img/delete.png'
import { checkExpired, formattedExpiry, getCardIcon } from '../../utils/helper'

function ListItems(props) {
    const { data, handleDelete, handleDetails, handleDefaultCard } = props
   
    const handleClick = (item) => {
        if(handleDetails){
            handleDetails(item)
        }
    }

    return (
        <div className='ms-2 me-2'>
           
            <ListGroup className="list-group-flush">
                {data?.length > 0 ? data?.map((item, index) =>
                    <ListGroup.Item as="li" className={`${item?.is_default === '1' ? 'bg-success bg-opacity-10 ' : ''}d-flex justify-content-between align-items-center border rounded  my-2`} key={index} onClick={() => handleClick(item)} >
                        <Image className='me-2' src={getCardIcon(item?.card_type)} width="40" />
                        <div className="ms-2 me-auto lh-1"> <div className="fw-semibold">{`Card ending in ${item?.card_last_four}`}</div>
                        <span className={`${(checkExpired(item?.expiry) || item?.is_expired == 1) ? 'd-block mt-1 text-danger fw-bold ' : ''}mainSubHeadingList`}>{(checkExpired(item?.expiry) || item?.is_expired == 1) ? <>{formattedExpiry(item?.expiry)}&nbsp;&nbsp;<span className='border border-danger text-danger d-inline-block p-1 rounded small'>Expired</span></> : `Expires ${formattedExpiry(item?.expiry)}`}</span></div>
                        
                            {data?.length > 1 || (checkExpired(item?.expiry) || item?.is_expired == 1)?
                            (item?.is_default == '0' || checkExpired(item?.expiry) || item?.is_expired == 1) && <a className='text-center me-2 border border-danger p-1 rounded-circle' style={{width: '30px', height: '30px'}} onClick={() => handleDelete(item?.id)}>
                                <i className='fa fa-trash text-danger'></i>
                            </a> : null}
                            {(item?.is_default == '1') ? <>
                                <span className='text-center me-2 border border-success p-1 rounded-circle' style={{width: '30px', height: '30px'}}>
                                    <i className='fa fa-check text-success'></i>
                                </span>
                                <span className='small mainSubHeadingList'>Default Card</span>
                            </> : 
                            checkExpired(item?.expiry) ? null : <a className='text-center border border-secondary p-1 rounded-circle' title="Make this default" style={{width: '30px', height: '30px'}} onClick={() => handleDefaultCard(item)}>
                                <i className='fa fa-check text-secondary'></i>
                            </a>}
                    </ListGroup.Item>
                ) : <NoData message='No Card Details Found.'/>}
            </ListGroup>
        </div>
    )
}

ListItems.propTypes = {
    dispatch: PropTypes.func,
    data: PropTypes.array,
    handleDelete: PropTypes.func,
    handleDetails: PropTypes.func,
    handleDefaultCard: PropTypes.func,
}

ListItems.defaulProps = {
    dispatch: noop,
    data: EMPTY_ARRAY,
    handleDelete: noop,
    handleDetails: noop,
    handleDefaultCard: noop
}

function mapStateToProps() {
    return {
        
    }
}
export default connect(mapStateToProps)(ListItems)
